export function StagingBanner() {
    return (
        <div
            className="fixed top-0 left-0 right-0 z-50 h-12 flex items-center justify-center bg-wait-bg text-wait text-subhead font-semibold"
            role="banner"
        >
            Ambiente de testes: os dados aqui não são reais
        </div>
    );
}
